import React from "react"
import {
  ActionType,
  BrandLogoBlock,
  NavTab,
  SideNavFrame,
  useSideNavCollapse,
} from "../side-nav"

// Side navigation glyphs from the design system (currentColor).
import { ReactComponent as WalletIcon } from "assets/svg/side-nav/wallet.svg"
import {
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline"

import { useAuthStore } from "stores"
import { isPadeDomain } from "utils/utils"
import { useCustomizationSettingsStore } from "stores/customization-settings"

export const SideNavigationBar: React.FC<{
  isSidebarOpen: boolean
  toggleSidebar: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ isSidebarOpen, toggleSidebar }) => {
  const { compact } = useSideNavCollapse()
  const { user } = useAuthStore()
  const { customizationSettings } = useCustomizationSettingsStore()

  const actions: ActionType[] = [
    {
      title: "Payslips",
      icon: <ClipboardDocumentListIcon className="w-4" />,
      route: "/employee/susp-exit/payslips",
      patterns: [{ path: "/employee/sus-exit/payslips/*" }],
      enabled: true,
      badge: false,
    },
    {
      title: "Wallet",
      icon: <WalletIcon className="w-4" />,
      enabled: true,
      badge: false,
      subActions: [
        {
          title: "Overview",
          route: "wallet/cross-border/overview",
          patterns: [
            {
              path: "/employee/dashboard/wallet/cross-border/overview/*",
            },
            {
              path: "/employee/dashboard/wallet/cross-border/local/*",
            },
            {
              path: "/employee/dashboard/wallet/cross-border/view/*",
            },
            {
              path: "/employee/dashboard/wallet/cross-border/swap-money/*",
            },
            {
              path: "/employee/dashboard/wallet/cross-border/send-money/*",
            },
            {
              path: "/employee/dashboard/wallet/cross-border/move-funds/*",
            },
          ],
          enabled: user?.userOrganisationId === 108 ? false : true,
        },
        {
          title: "Overview",
          route: "wallet/cross-border/local",
          patterns: [
            {
              path: "/employee/dashboard/wallet/cross-border/local/*",
            },
          ],
          enabled: user?.userOrganisationId === 108 ? true : false,
        },

        {
          title: "Transactions",
          route: "wallet/cross-border/transactions",
          patterns: [
            {
              path: "/employee/dashboard/wallet/cross-border/transactions/*",
            },
          ],
          enabled: true,
        },
        {
          title: "Transfers",
          route: "wallet/cross-border/transfers",
          patterns: [
            {
              path: "/employee/dashboard/wallet/cross-border/transfers/*",
            },
          ],
          enabled: true,
        },
        {
          title: "Earned Wage Access",
          route: "wallet/earned-wage-access/overview",
          patterns: [
            {
              path: "/employee/dashboard/wallet/earned-wage-access/overview/*",
            },
          ],
          enabled: true,
        },
      ],
    },
  ]

  const handleToggleSidebar = () => {
    toggleSidebar(false)
    document.body.classList.remove("overflow-hidden")
  }

  return (
    <>
      {isSidebarOpen && (
        <div
          className="md:hidden fixed inset-0 z-20 bg-black/30  cursor-pointer backdrop-blur-sm"
          onClick={handleToggleSidebar}
        />
      )}
      <SideNavFrame
        isSidebarOpen={isSidebarOpen}
        compact={compact}
        zIndexClass="z-30"
      >
        <div className="h-full w-full py-[18px] px-3 flex flex-col justify-start gap-3">
          {/* Brand */}
          <BrandLogoBlock
            compact={compact}
            orgName={user?.userOrganisation}
            alt="PaidHR Logo"
            src={
              isPadeDomain()
                ? "https://padefiles.blob.core.windows.net/images/2e8c7aa5-0792-4efd-ae24-ae166052d374.svg "
                : customizationSettings?.brand?.menuLogoUrl
            }
          />
          {/* Menu */}
          <div className="h-full w-full flex flex-col gap-9">
            <div className="h-auto overflow-y-auto w-full flex flex-col gap-0.5">
              {actions.map((action, index) =>
                !action.enabled ? (
                  ""
                ) : (
                  <NavTab
                    action={action}
                    key={index}
                    index={index}
                    toggleSidebar={handleToggleSidebar}
                    compact={compact}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </SideNavFrame>
    </>
  )
}
